import React from 'react';

import { Wrap } from './styles';

/**
 * This is displayed to the user where there are no results for their lookup
 */
const NoResults = () => (
  <Wrap>
    <p>Sorry, no results were returned for your search. Please try again.</p>
  </Wrap>
);

export default NoResults;
